import { createCommand } from '../bridge-api-command-creator';

/**
 * A command sent by a bridge API client to discover a specific client.
 *
 * @summary {@link CommandProperties.senderId} is sending a beacon for {@link CommandProperties.receiverId}.
 */
export const DiscoveryCommand = createCommand('discovery-command');

/**
 * A command sent by a bridge API client in response to discovery attempts {@link DiscoveryCommand} from a specific client.
 *
 * @summary {@link CommandProperties.senderId} is responding to a beacon from {@link CommandProperties.receiverId}.
 */
export const ReachableCommand = createCommand('reachable-command');

/**
 * A command sent by a bridge API client to notify all other clients that it is being torn down.
 *
 * @summary {@link CommandProperties.senderId} is notifying all clients that it is shutting down and should be removed from their registries.
 */
export const TeardownCommand = createCommand('teardown-command');
